import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=4a931e70&scoped=true&"
import script from "./detailed.vue?vue&type=script&lang=ts&"
export * from "./detailed.vue?vue&type=script&lang=ts&"
import style0 from "./detailed.vue?vue&type=style&index=0&id=4a931e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a931e70",
  null
  
)

export default component.exports